let isMenuOpen = false;
let lastFocusedElement = null;

document.addEventListener(
	'keydown',
	function (e) {
		if (e.key === 'Escape' || e.key === 'Esc') {
			if (isMenuOpen) {
				e.preventDefault();
				e.stopPropagation();

				const menuIcon = document.querySelector('.menu-icon');
				const menuToggle = document.querySelector('.menu-toggle');
				const offCanvas = document.querySelector('.off-canvas');

				if (menuIcon) {
					menuIcon.classList.remove('opened');
					menuIcon.setAttribute('aria-expanded', 'false');
				}
				if (menuToggle) {
					menuToggle.classList.remove('menu-open');
				}
				if (offCanvas) {
					offCanvas.setAttribute('aria-hidden', 'true');
				}
				document.body.classList.remove('offcanvas-triggered');

				isMenuOpen = false;

				if (menuIcon) {
					menuIcon.focus();
				}
			}
		}
	},
	true
);

document.addEventListener('DOMContentLoaded', () => {
	const menuIcon = document.querySelector('.menu-icon');
	const offCanvas = document.querySelector('.off-canvas');
	const menuToggle = document.querySelector('.menu-toggle');

	document.addEventListener('keydown', function (e) {
		if (!isMenuOpen) return;

		if (e.key === 'Tab') {
			const focusableElements = getFocusableElements();
			const lastFocusable = focusableElements[focusableElements.length - 1];

			if (e.target === lastFocusable && !e.shiftKey) {
				e.preventDefault();
				menuIcon.focus();
			}
			if (e.target === menuIcon && e.shiftKey) {
				e.preventDefault();
				lastFocusable.focus();
			}
		}
	});

	function getFocusableElements() {
		const focusableSelectors = 'a[href], button, [tabindex]:not([tabindex="-1"])';
		return Array.from(offCanvas.querySelectorAll(focusableSelectors));
	}

	function openMenu() {
		isMenuOpen = true;
		lastFocusedElement = document.activeElement;

		menuIcon.classList.add('opened');
		menuToggle.classList.add('menu-open');
		document.body.classList.add('offcanvas-triggered');

		menuIcon.setAttribute('aria-expanded', 'true');
		offCanvas.setAttribute('aria-hidden', 'false');

		setTimeout(() => {
			menuIcon.focus();
		}, 100);
	}

	function closeMenu() {
		isMenuOpen = false;

		menuIcon.classList.remove('opened');
		menuToggle.classList.remove('menu-open');
		document.body.classList.remove('offcanvas-triggered');

		menuIcon.setAttribute('aria-expanded', 'false');
		offCanvas.setAttribute('aria-hidden', 'true');

		if (lastFocusedElement) {
			lastFocusedElement.focus();
		}
	}

	menuIcon.addEventListener('click', function () {
		if (isMenuOpen) {
			closeMenu();
		} else {
			openMenu();
		}
	});

	document.addEventListener('click', function (e) {
		if (isMenuOpen && !offCanvas.contains(e.target) && !menuToggle.contains(e.target)) {
			closeMenu();
		}
	});

	const allMenuItemsWithChildren = document.querySelectorAll('.off-canvas .menu-item-has-children > a');
	allMenuItemsWithChildren.forEach((menuItem) => {
		menuItem.setAttribute('aria-expanded', 'false');
		menuItem.setAttribute('aria-haspopup', 'true');
	});

	// Off-canvas menu toggle for sub-menus
	const topLevelMenuItems = document.querySelectorAll('.off-canvas .top-level.menu-item-has-children > a');
	topLevelMenuItems.forEach((menuItem) => {
		menuItem.addEventListener('click', function (e) {
			e.preventDefault();
			const parent = this.parentNode;
			const isOpen = parent.classList.contains('is-open');

			parent.classList.toggle('is-open');

			const subMenu = this.nextElementSibling;
			if (subMenu && subMenu.classList.contains('sub-menu')) {
				subMenu.style.display = isOpen ? 'none' : 'block';
				subMenu.style.transition = 'all 400ms ease';

				// Update ARIA attributes
				this.setAttribute('aria-expanded', !isOpen);
				subMenu.setAttribute('aria-hidden', isOpen);
			}
		});

		// Add keyboard support for sub-menu toggles
		menuItem.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				this.click();
			}
		});
	});
});
